/* eslint-disable @typescript-eslint/no-explicit-any */
import { RootState } from '@/app/store';
import { ITracksId } from '@/interface';
import { beezerApi } from '@/services/deezer';
import { spotifyApi } from '@/services/spotify';
import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  PayloadAction
} from '@reduxjs/toolkit';

interface Track {
  id: string | undefined;
  items: ITracksId[];
}

const searchAdapter = createEntityAdapter<Track>({
  //selectId: (track: ITracksId) => track.track.id,
  //sortComparer: (a: any, b: any) => a.track.name.localeCompare(b.track.name)
});

export const getTrackBySearch = createAsyncThunk(
  'search/getTrackBySearch',
  async (search: string) => {
    const response = await spotifyApi.search(search, ['track']);
    const newResults = {
      items: {
        items: response.body.tracks?.items.map((item) => {
          return {
            track: {
              ...item,
              track: {
                ...item
              }
            }
          };
        })
      }
    };

    return newResults.items;
  }
);

export const getTrackBeezerBySearch = createAsyncThunk(
  'search/getTrackBeezerBySearch',
  async (search: string) => {
    const response = await beezerApi('search?q=' + search);
    const data = await response.json();
    const result = data?.data.slice(0, 30);
    return {
      items: result?.map((item: any) => {
        return {
          id: item.id,
          track: {
            ...item,
            name: item.title,
            album: {
              ...item.album,
              images: [
                {
                  url: item.album.cover
                }
              ]
            },
            artists: [
              {
                ...item.artist,
                name: item.artist.name
              }
            ],
            preview_url: item.preview,
            track: {
              ...item,
              name: item.title,
              album: {
                ...item.album,
                images: [
                  {
                    url: item.album.cover
                  }
                ]
              },
              artists: [
                {
                  ...item.artist,
                  name: item.artist.name
                }
              ],
              preview_url: item.preview
            }
          }
        };
      })
    };
  }
);

export const searchSlice = createSlice({
  name: 'search',
  initialState: searchAdapter.getInitialState({
    searchResults: {
      items: [] as ITracksId[]
    },
    status: {
      searchState: 'empty'
    },
    results: {} as ITracksId[],
    isWriting: false as boolean
  }),
  reducers: {
    setSearchResults: (state: any, action: PayloadAction<any>) => {
      const newResults = [
        ...state.searchResults.items
          .filter(
            (track: { track: { preview_url: string | null | undefined } }) =>
              track.track.preview_url !== undefined &&
              track.track.preview_url !== null &&
              track.track.preview_url !== ''
          )
          .map((item: any) => {
            if (item.track.id === action.payload.id) {
              return {
                ...item,
                track: {
                  ...item.track,
                  isFavorite: action.payload.isFavorite ? true : false
                }
              };
            }
            return item;
          })
      ];
      state.searchResults.items = [...newResults];
      //searchAdapter.upsertMany(state, action.payload)
    },
    setIsWriting: (
      state: { isWriting: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.isWriting = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getTrackBySearch.pending, (state) => {
      state.status.searchState = 'loading';
    });
    builder.addCase(getTrackBySearch.rejected, (state) => {
      state.status.searchState = 'failed';
    });
    builder.addCase(getTrackBySearch.fulfilled, (state, action) => {
      state.searchResults = action.payload as any;
      state.status.searchState = 'ok';
    });
    builder.addCase(getTrackBeezerBySearch.pending, (state) => {
      state.status.searchState = 'loading';
    });
    builder.addCase(getTrackBeezerBySearch.rejected, (state) => {
      state.status.searchState = 'failed';
    });
    builder.addCase(getTrackBeezerBySearch.fulfilled, (state: any, action) => {
      state.searchResults = action.payload as any;
      //console.debug(state.ids)
      state.status.searchState = 'ok';
      searchAdapter.addMany(state, action.payload);
    });
  }
});

export const { setSearchResults, setIsWriting } = searchSlice.actions;

export const selectSearchResults = (state: RootState) => state.search;

export const {
  selectAll: selectAllSearchResults,
  selectIds: selectSearchResultsIds,
  selectById: selectSearchResultsById,
  selectEntities: selectSearchResultsEntities
} = searchAdapter.getSelectors<RootState>((state) => state.search);
export default searchSlice.reducer;
